var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-badge',{attrs:{"pill":"","variant":_vm.activeStatus.color}},[_vm._v(" "+_vm._s(_vm.activeStatus.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }